import { appEntry } from '@/mocks/home';

export default function AppSection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="app" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-r from-primary-500/5 via-accent-100/40 to-primary-50/30 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-4">
              {appEntry.title}
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
              {appEntry.description}
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => handleScroll('#contact')}
                className="px-6 py-2.5 rounded-full bg-foreground-900 hover:bg-foreground-800 text-background-50 text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-apple-fill mr-1.5"></i>iOS 下载
              </button>
              <button
                onClick={() => handleScroll('#contact')}
                className="px-6 py-2.5 rounded-full bg-foreground-900 hover:bg-foreground-800 text-background-50 text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-android-fill mr-1.5"></i>Android 下载
              </button>
            </div>
          </div>
          <div className="flex-shrink-0 w-36 h-36 bg-background-50 rounded-2xl flex items-center justify-center border-2 border-secondary-200/60">
            <div className="text-center">
              <i className="ri-qr-code-line text-5xl text-foreground-700"></i>
              <p className="text-xs text-foreground-500 mt-2">{appEntry.qrLabel}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}